import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarTopComponent } from './views/navbar-top/navbar-top.component';

import { NavbarMainComponent } from './views/navbar-main/navbar-main.component';
import { NavbarComponent } from './navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { SanitizePipeModule } from '../common/pipe/sanitize/sanitize-pipe.module';
import { MathCeilPipe } from './views/navbar-main/math-ceil.pipe';

@NgModule({
  declarations: [NavbarTopComponent, NavbarComponent, NavbarMainComponent, MathCeilPipe],
  imports: [CommonModule, RouterModule, FormsModule, SanitizePipeModule],
  exports: [NavbarComponent],
})
export class NavbarModule {}
